export default __webpack_public_path__ + "static/media/faq_bg_wattermark.2ef9fbe0.png";